import React, { useEffect, useState } from "react";
import axios from "axios";
import { Container, Typography, Box, Grid, useTheme, useMediaQuery } from "@mui/material";

function BusinessIntelligence() {
    const [business, setBusiness] = useState([]);
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

    useEffect(() => {
        axios
            .get("/files/solutions/businessIntelligence.txt")
            .then((res) => setBusiness(res.data))
            .catch((err) => console.error(err));
    }, []);

    const renderDescription = (desc) => {
        if (typeof desc === "string") {
            return (
                <Typography variant="body1" sx={{ mb: 2, fontFamily: "Raleway, sans-serif" }}>
                    {desc}
                </Typography>
            );
        } else if (Array.isArray(desc)) {
            return desc.map((item, idx) => {
                if (typeof item === "string") {
                    return (
                        <Typography
                            key={idx}
                            variant="body1"
                            sx={{ mb: 1, pl: 2, fontFamily: "Raleway, sans-serif" }}
                        >
                            • {item}
                        </Typography>
                    );
                } else if (typeof item === "object") {
                    return (
                        <Box key={idx} sx={{ mb: 2, pl: 2 }}>
                            <Typography variant="subtitle1" sx={{ fontWeight: "bold", mb: 1 }}>
                                {item.title}
                            </Typography>
                            {renderDescription(item.description)}
                        </Box>
                    );
                } else return null;
            });
        } else return null;
    };

    return (
        <Box sx={{ minHeight: "100vh", py: 2 }}>
            <Container maxWidth="lg">
                <Typography
                    align="center"
                    gutterBottom
                    sx={{
                        fontWeight: "bold",
                        color: "#030366",
                        mb: { xs: 4, sm: 5, md: 6 },
                        mt: 7,
                        fontSize: {
                            xs: "1.8rem", // mobile
                            sm: "2.2rem", // tablet
                            md: "2.8rem", // laptop
                            lg: "3rem",  // desktop
                        },
                    }}
                >
                    Business Intelligence Solutions
                </Typography>
                {business.map((section, index) => (
                    <Box key={index} sx={{ mb: 4 }}>
                        <Typography
                            variant={isMobile ? "h5" : "h4"}
                            sx={{ fontWeight: "bold", mb: 2, color: "#030366", textAlign: isMobile ? "center" : "left" }}
                        >
                            {section.title}
                        </Typography>

                        {renderDescription(section.description)}

                        {index === 0 && (
                            <Box sx={{ textAlign: "center", mt: 3 }}>
                                <img
                                    src="/images/bi1.jpg"
                                    alt="Business Intelligence"
                                    style={{
                                        maxWidth: "100%",
                                        height: "auto",
                                        borderRadius: "15px",
                                        boxShadow: "0px 4px 12px rgba(0,0,0,0.15)"
                                    }}
                                />
                            </Box>
                        )}

                        {section.title?.trim().toLowerCase() ===
                            "bi consulting offerings at vensyx data solutions include:" &&
                            (
                                <Box sx={{ textAlign: "center", mt: 3 }}>
                                    <img
                                        src="/images/bi2.jpg"
                                        alt="BI Consulting Offerings"
                                        style={{
                                            maxWidth: "100%",
                                            height: "auto",
                                            borderRadius: "10px",
                                            boxShadow: "0px 4px 10px rgba(0,0,0,0.15)"
                                        }}
                                    />
                                </Box>
                            )
                        }
                    </Box>
                ))}
            </Container>
        </Box>
    );
}

export default BusinessIntelligence;


// "title": "Business Intelligence Solutions", removed for first content title